import ThemePluginFiles from './class/ThemePluginFilesBase';

const T_and_P = new ThemePluginFiles();



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro-theme-plugin-files/asset/src/js/script.js